import { useRef } from "react";
import dynamic from "next/dynamic";
import CityHeroSection from "@/components/city/sections/CityHeroSection";
import TourCard from "@/components/homepage/cards/TourCard";
import {breakpoints} from "@/styles/sizes";
import styled from "styled-components";

// Lazy load below-the-fold components
const CityTextImageSection = dynamic(() => import("@/components/city/sections/CityTextImageSection"));
const CityToursSection = dynamic(() => import("@/components/city/sections/CityToursSection"));

export default function CityTourGroupPage({ data }) {
    const scrollToDivRef = useRef(null);

    const { reviewOverlay, page, socialLinks } = data?.data || {};
    const {
        heroImage,
        textAndImageImage,
        tours,
        data: pageData,
        name,
    } = page || {};
    const { hero, textAndImage, tours: toursData } =
    pageData || {};

    return (
        <div>
            {/* Hero Section (Above-the-Fold) */}
            <CityHeroSection
                reviewOverlayData={reviewOverlay}
                scrollToDivRef={scrollToDivRef}
                heroMedia={heroImage}
                backgroundImageUrl={heroImage?.url}
                socialLinks={socialLinks}
                subtitle={hero?.subtitle}
                heroTitle={hero?.title}
                breadcrumbds={[
                    { title: "Home", link: "/" },
                    { title: hero?.title },
                ]}
                dropdownData={pageData?.showDropdown ? pageData?.dropdowns : []}
            />

            {/* Text and Image Section */}
                <div ref={scrollToDivRef}>
                    {(textAndImage?.title || textAndImage?.description) && textAndImageImage && (
                        <CityTextImageSection
                            reviewOverlayData={reviewOverlay}
                            title={textAndImage?.title}
                            image={textAndImageImage}
                            description={textAndImage?.description}
                            buttons={textAndImage?.buttons}
                        />
                    )}
                </div>

            {/*/!* Tours Section *!/*/}
            {/*    <div id={'all-tours'} style={{marginBottom: '100px'}}>*/}
            {/*        <CityToursSection*/}
            {/*            title={toursData?.title}*/}
            {/*            subtitle={toursData?.subtitle}*/}
            {/*            tours={tours}*/}
            {/*        />*/}
            {/*    </div>*/}



            {/* Tours Section */}
            <div className="container">
                <div style={{ padding: "20px" }}>
                    <GridWrapper>
                        {tours?.map((item, index) => (
                            <TourCard item={item} key={index} />
                        ))}
                    </GridWrapper>
                </div>
            </div>



        </div>
    );
}


const GridWrapper = styled.div`
    margin: 50px 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
        padding: 20px;
    }
`;
